enum MovementsMenuTypesEnum {
  MovementScreenIncludeBeneficiary = 'MovementScreenIncludeBeneficiary',
  MovementScreenCancelIncludeBeneficiary = 'MovementScreenCancelIncludeBeneficiary',
  MovementScreenChangeIncludeBeneficiary = 'MovementScreenChangeIncludeBeneficiary',
  MovementScreenChangeUnitIncludeBeneficiary = 'MovementScreenChangeUnitIncludeBeneficiary',
  MovementScreenIncludeDependent = 'MovementScreenIncludeDependent',
  MovementScreenMarriageIncludeDependent = 'MovementScreenMarriageIncludeDependent',
  MovementScreenBirthIncludeDependent = 'MovementScreenBirthIncludeDependent',
  MovementScreenCancelIncludeDependent = 'MovementScreenCancelIncludeDependent',
  MovementScreenChangeIncludeDependent = 'MovementScreenChangeIncludeDependent',
  MovementScreenNewPreCancellationBeneficiary = 'MovementScreenNewPreCancellationBeneficiary',
  MovementScreenCancelPreCancellationBeneficiary = 'MovementScreenCancelPreCancellationBeneficiary',
  MovementScreenNewPreCancellationDependent = 'MovementScreenNewPreCancellationDependent',
  MovementScreenCancelPreCancellationDependent = 'MovementScreenCancelPreCancellationDependent',
  MovementScreenMajorityControlPreCancellationDependent = 'MovementScreenMajorityControlPreCancellationDependent',
  MovementScreenSuspendPreCancellation = 'MovementScreenSuspendPreCancellation',
  MovementScreenChangePlanBeneficiary = 'MovementScreenChangePlanBeneficiary',
  MovementScreenChangeUnitBeneficiary = 'MovementScreenChangeUnitBeneficiary',
  MovementScreenChangeDataBeneficiary = 'MovementScreenChangeDataBeneficiary',
  MovementScreenCancelChangeDataBeneficiary = 'MovementScreenCancelChangeDataBeneficiary',
  MovementScreenChangeDataDependent = 'MovementScreenChangeDataDependent',
  MovementScreenCancelChangeDataDependent = 'MovementScreenCancelChangeDataDependent',
  MovementScreenIncludePendingRequestAuthorization = 'MovementScreenIncludePendingRequestAuthorization',
  MovementScreenExcludePendingRequestAuthorization = 'MovementScreenExcludePendingRequestAuthorization',
  MovementScreenIncludeTransfer = 'MovementScreenIncludeTransfer',
  MovementScreenCancelTransfer = 'MovementScreenCancelTransfer',
  MovementScreenSuspendMedicalCare = 'MovementScreenSuspendMedicalCare',
  MovementScreenReactivateMedicalCare = 'MovementScreenReactivateMedicalCare',
  MovementScreenCancelRequestSuspendedBeneficiaries = 'MovementScreenCancelRequestSuspendedBeneficiaries',
}

interface MovementsMenuPermissions {
  menu: MovementsMenuTypesEnum;
  display: true;
}

interface GetMovementsMenuPermissionsResponseDTO {
  content: MovementsMenuPermissions[];
}

interface GetMovementsMenuPermissionsRequestDTO {
  partnerCompany: string;
}

export {
  type GetMovementsMenuPermissionsResponseDTO,
  type GetMovementsMenuPermissionsRequestDTO,
  type MovementsMenuPermissions,
  MovementsMenuTypesEnum,
};
